import * as types from 'store/modules/hres6lu/mutation-types'
import hres6lu from 'api/hres6lu'
import swal from 'sweetalert'
import { sendApprove } from 'assets/js/sendApprove.js'
import hres6luLabels from 'assets/labels/hres6lu'
import { hres6luMaxRowspan, hres6luColumns } from 'assets/columns/hres6lu'
import configLabel from 'src/../config/label'

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    labels: hres6luLabels,
    columns: hres6luColumns(),
    maxRowspan: hres6luMaxRowspan,
    index: {
      total: 0,
      rows: []
    },
    detail: {
      tab1: {},
      tab2: {
        detail: {},
        table: {
          total: 0,
          rows: []
        }
      },
      tab3: {
        detail: {},
        table: {
          total: 0,
          rows: []
        }
      }
    },
    indexSelected: []
  },
  getters: {
    [types.GET_HRES6LU_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRES6LU_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRES6LU_MAX_ROWSPAN] (state) {
      return state.maxRowspan
    },
    [types.GET_HRES6LU_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRES6LU_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRES6LU_INDEX] (state) {
      return state.index
    },
    [types.GET_HRES6LU_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRES6LU_DETAIL] (state) {
      return state.detail
    }
  },
  mutations: {
    [types.SET_HRES6LU_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRES6LU_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRES6LU_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
        state.columns[keyLang].detailTab2 = configLabel.replaceLabelToColumns(state.columns[keyLang].detailTab2, labels[keyLang])
        state.columns[keyLang].detailTab3 = configLabel.replaceLabelToColumns(state.columns[keyLang].detailTab3, labels[keyLang])
      }
    },
    [types.SET_HRES6LU_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_HRES6LU_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_HRES6LU_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRES6LU_DETAIL] (state, data) {
      state.detail = data
    }
  },
  actions: {
    [types.TOGGLE_HRES6LU_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_HRES6LU_INDEX_DISP, indexDisp)
      commit(types.SET_HRES6LU_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_HRES6LU_COLUMNS_LABELS] ({ commit }) {
      hres6lu.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES6LU_COLUMNS, data.labels)
          commit(types.SET_HRES6LU_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES6LU_INDEX] ({ commit }, searchParams) {
      hres6lu.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES6LU_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES6LU_DETAIL] ({ commit }, searchParams) {
      hres6lu.getDetail(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES6LU_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES6LU_DROPDOWNS] ({ commit }) {
      hres6lu.getDropdowns()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES6LU_DROPDOWNS, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRES6LU_SEND_APPROVE] ({ commit, dispatch }, indexRows) {
      sendApprove({
        dataRows: indexRows,
        sendApprove: hres6lu.postSendApprove,
        dispatch: dispatch,
        dispatchType: types.RECEIVED_HRES6LU_INDEX
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hres6lu/index.js